import React, { useState } from 'react';
import Sticky from 'react-sticky-el';
import { useNavigate } from 'react-router-dom';
import { ERROR_WITHOUT_SECTION } from 'framework/ui/ui-builder';
import { Stack } from '@mui/material';
import { useUiTheme } from 'framework/uiTheme';

type FormListButtonsLayoutProps = {
  submitAction: () => void;
  isSubmitEnabled: boolean;
  isShowError: boolean;
};

const FormListButtonsLayout = ({ submitAction, isSubmitEnabled, isShowError }: FormListButtonsLayoutProps) => {
  const navigate = useNavigate();
  const [length] = useState(navigate.length - 1);
  const { Button } = useUiTheme();

  const onCancel = () => {
    navigate(length - navigate.length);
  };

  return (
    <Sticky mode="bottom" stickyClassName="sticky-buttons-element sticky" stickyStyle={{ zIndex: 100 }}>
      <Stack
        className="floating-btns"
        sx={{
          position: 'relative',
          inset: 'auto 0 0',
          zIndex: 100,
          p: '16px',
          mx: '-16px',
          backgroundColor: 'transparent',
          transition: 'background 0.2s, padding 0.2s',
          '.sticky &': {
            backgroundColor: 'background.paper',
            transition: 'background 0.2s, padding 0.1s, opacity 0.1s',
          },
        }}
      >
        <Stack className="form-buttons-wrapper" direction="row" useFlexGap sx={{ flexWrap: 'wrap', gap: '10px' }}>
          <Stack
            className="btn-area"
            direction="row"
            useFlexGap
            sx={{
              flex: '0 1 auto',
              flexShrink: 0,
              alignItems: 'flex-start',
              gap: '10px',
              width: 'auto',
              minWidth: '200px',
              maxWidth: 'none',
              '&& > .MuiButton-root:not(:last-child)': { mr: 0 },
            }}
          >
            <Button data-testid="submit-button" type="submit" onClick={submitAction} disabled={!isSubmitEnabled}>
              Submit
            </Button>
            <Button data-testid="cancel-btn" variant="outlined" type="button" onClick={onCancel}>
              Cancel
            </Button>
          </Stack>
          {isShowError && (
            <div className="form-errors">
              <div>{ERROR_WITHOUT_SECTION}</div>
            </div>
          )}
        </Stack>
      </Stack>
    </Sticky>
  );
};

export default FormListButtonsLayout;
